import Axios from 'axios';
import Vue from 'vue';
import i18n from '../../i18n';
import { API_HOST } from '../../config/app-const';

const state = {
    briefings: {
        isBusy: false,
        data: null,
        error: null
    }
};

const mutations = {
    GET_BRIEFINGS_BUSY(state, payload) {
        state.briefings.isBusy = payload;
    },
    GET_BRIEFINGS_SUCCESS(state, payload) {
        state.briefings.data = payload;
        state.briefings.error = null;
    },
    GET_BRIEFINGS_FAIL: (state, payload) => {
        state.briefings.error = payload;
    }
};

const actions = {
    getBriefingFiles: ({ commit, rootState }, { projectUid }) => {
        commit("GET_BRIEFINGS_BUSY", true)
        const { accessToken } = rootState.user.user.data;
        const config = {
            headers: { Authorization: `Token token=${accessToken}` }
        };
        return Axios.get(`${API_HOST}/analysis/${projectUid}/files`, config)
            .then((response) => {
                commit("GET_BRIEFINGS_SUCCESS", response.data.data)
            })
            .catch((error) => {
                console.error(error);
                Vue.notify({
                    group: 'store_notifications',
                    type: 'error',
                    text: i18n.t('messages.request.error')
                });
                commit("GET_BRIEFINGS_FAIL", error);
            })
            .finally(() => {
                commit("GET_BRIEFINGS_BUSY", false);
            });
    },
    removeBriefingFiles: ({ commit, rootState }, { projectUid, briefing = {} }) => {
        commit("GET_BRIEFINGS_BUSY", true)
        const { accessToken } = rootState.user.user.data;
        const config = {
            headers: { Authorization: `Token token=${accessToken}` },
            data: briefing
        };
        return Axios.delete(`${API_HOST}/analysis/${projectUid}/files`, config)
            .then((response) => {
                commit("GET_BRIEFINGS_SUCCESS", response.data.data)
            })
            .catch((error) => {
                console.error(error);
                Vue.notify({
                    group: 'store_notifications',
                    type: 'error',
                    text: i18n.t('messages.request.error')
                });
                commit("GET_BRIEFINGS_FAIL", error);
            })
            .finally(() => {
                commit("GET_BRIEFINGS_BUSY", false);
            });
    }
};

export default {
    namespaced: true,
    state,
    mutations,
    actions
};